import LoadingComponent from '@/pages/components/common/LoadingComponent'
import Loading1 from '@/pages/components/common/Loading1'
import Loadable from 'react-loadable'

export default [
  {
    component: Loadable({
      loader: () => import('@/pages/equipmentMall/mallHome/index'),
      loading: Loading1
    }),
    path: '/courierView/equipmentMall/mallHome'
  },
  {
    component: Loadable({
      loader: () => import('@/pages/equipmentMall/mallDetail/index'),
      loading: Loading1
    }),
    path: '/courierView/equipmentMall/mallDetail'
  },
  {
    component: Loadable({
      loader: () => import('@/pages/equipmentMall/mallList/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/equipmentMall/mallList'
  },
  {
    component: Loadable({
      loader: () => import('@/pages/equipmentMall/sureOrder/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/equipmentMall/sureOrder'
  },
  {
    component: Loadable({
      loader: () => import('@/pages/equipmentMall/checkStation/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/equipmentMall/checkStation'
  },
  {
    component: Loadable({
      loader: () => import('@/pages/equipmentMall/checkAddress/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/equipmentMall/checkAddress'
  },
  {
    component: Loadable({
      loader: () => import('@/pages/equipmentMall/orderList/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/equipmentMall/orderList'
  },
  {
    component: Loadable({
      loader: () => import('@/pages/equipmentMall/orderDetail/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/equipmentMall/orderDetail'
  },
  {
    component: Loadable({
      loader: () => import('@/pages/equipmentMall/couponCollectionCenter/index'),
      loading: LoadingComponent
    }),
    exact: true,
    path: '/courierView/equipmentMall/couponCollectionCenter',
    meta: {
      title: '领券中心'
    }
  },
  {
    component: Loadable({
      loader: () => import('@/pages/equipmentMall/mallSearchPage/index'),
      loading: LoadingComponent
    }),
    exact: true,
    path: '/courierView/equipmentMall/mallSearchPage',
    meta: {
      title: '搜索'
    }
  },
  {
    component: Loadable({
      loader: () => import('@/pages/equipmentMall/activityList/index'),
      loading: LoadingComponent
    }),
    exact: true,
    path: '/courierView/equipmentMall/activityList',
    meta: {
      title: ''
    }
  },
  {
    component: Loadable({
      loader: () => import('@/pages/equipmentMall/logisticsList/index'),
      loading: LoadingComponent
    }),
    exact: true,
    path: '/courierView/equipmentMall/logisticsList',
    meta: {
      title: '物流信息'
    }
  },
  {
    component: Loadable({
      loader: () => import('@/pages/equipmentMall/logisticsDetails/index'),
      loading: LoadingComponent
    }),
    exact: true,
    path: '/courierView/equipmentMall/logisticsDetails',
    meta: {
      title: '物流信息'
    }
  }
]
